var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#D8D8D8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(-1144 -348) translate(792 236) translate(56 112) translate(296) translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.333,
    d: "M4.553 8.473L10.559 4.149M5.8 18.475L3.622 11.214M15.911 20.178L8.089 20.178M13.441 4.149L19.467 8.487M20.378 11.214L18.2 18.475"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.222,
    cy: 3.333,
    r: 3.333,
    fill: "#D8D8D8",
    strokeWidth: 0.711
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.111,
    cy: 9.733,
    r: 3.333,
    fill: "#D8D8D8",
    strokeWidth: 0.711
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.911,
    cy: 20.4,
    r: 3.333,
    fill: "#D8D8D8",
    strokeWidth: 0.711
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.533,
    cy: 20.4,
    r: 3.333,
    fill: "#D8D8D8",
    strokeWidth: 0.711
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.333,
    cy: 9.733,
    r: 3.333,
    fill: "#D8D8D8",
    strokeWidth: 0.711
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0z",
    transform: "translate(-1144 -348) translate(792 236) translate(56 112) translate(296)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngles);
export default __webpack_public_path__ + "static/media/angles.c8c9655176fafdad4b0bb8b879a88c54.svg";
export { ForwardRef as ReactComponent };